import React, { useState, useContext } from 'react';
import { Container, Row, Col, Spinner, Button, Form, } from 'react-bootstrap';
import axios from "axios";
import $ from 'jquery';
import { AppContext } from '../App';
import { apiRequest } from '../utils/apiHelper';

export const Ads = () => {
	const { link, accessToken, setAccessToken, getAdLoad, bannerList, setBannerList, bannerOrder, setBannerOrder } = useContext(AppContext);
	const [picUploadLoad, setPicUploadLoad] = useState(false);
	const uploadImage = (e) => {
		e.preventDefault();
		apiRequest({
			url: `${link}api/cs/upload/ads/`,
			method: 'POST',
			data: { files: e.target.files[0] },
			headers: { "Content-Type": "multipart/form-data" },
			token: accessToken,
			setLoading: setPicUploadLoad,
			setAccessToken: setAccessToken,
			onSuccess: (data) => {
				setBannerList(data);
			}
		});
	}
	const [priorityChangeLoad, setPriorityChangeLoad] = useState(false);
	const changePriority = () => {
		$(".pr").val(null);
		apiRequest({
			url: `${link}api/cs/change/priority/ads/`,
			method: 'POST',
			data: { priority: bannerOrder },
			token: accessToken,
			setLoading: setPriorityChangeLoad,
			setAccessToken: setAccessToken,
			onSuccess: (data) => {
				setBannerList(data);
			}
		});
	}
	const [delId, setDelId] = useState();
	const [delLoad, setDelLoad] = useState(false);
	const DeleteImg = (id) => {
		apiRequest({
			url: `${link}api/cs/delete/ads/`,
			method: 'POST',
			data: { ad_id: id.substring(1) },
			token: accessToken,
			setLoading: setDelLoad,
			setAccessToken: setAccessToken,
			onSuccess: (data) => {
				setDelId();
				setBannerList(data);
			},
			onError: () => {
				setDelId();
			}
		});
	}
	const [visId, setVisId] = useState();
	const [visChangeLoad, setVisChangeLoad] = useState(false);
	const changeVisib = (id, status) => {
		apiRequest({
			url: `${link}api/cs/change/status/ads/`,
			method: 'POST',
			data: {
				ad_id: id.substring(1),
				status: status
			},
			token: accessToken,
			setLoading: setVisChangeLoad,
			setAccessToken: setAccessToken,
			onSuccess: (data) => {
				setVisId();
				setBannerList(data);
			},
			onError: () => {
				setVisId();
			}
		});
	}
	const [changeImgId, setChangeImgId] = useState();
	const [changeImgLoad, setChangeImgLoad] = useState();
	const changeImg = (id, e) => {
		e.preventDefault();
		apiRequest({
			url: `${link}api/cs/update/ads/`,
			method: 'POST',
			data: {
				file: e.target.files[0],
				ad_id: id.substring(1)
			},
			headers: { "Content-Type": "multipart/form-data" },
			token: accessToken,
			setLoading: setChangeImgLoad,
			setAccessToken: setAccessToken,
			onSuccess: (data) => {
				setChangeImgId();
				setBannerList(data);
			},
			onError: () => {
				setChangeImgId();
			}
		});
	}
	return (
		<Container className="py-3">
			<Row className='bdr2 br-3' >
				<Col xs="12" sm="12" md="12" lg="12" className="staff-type-header bgs1 d-grid p-2 bdrb2" >
					<span>{getAdLoad ? (<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>) : 'Banner images'}</span>
					<input type="file" id="upload" hidden onChange={(e) => { uploadImage(e) }} accept=".png, .jpg, .jpeg" />
					{
						picUploadLoad ? (
							<span className="please-wait-spinner p-2" ><Spinner animation="border" size="sm" /> Uploading...</span>
						) : (
							<Button onClick={() => { $('#upload').trigger("click") }} className="btn-t1"><i className="bi bi-plus-circle"></i> Add Image</Button>
						)
					}
				</Col>
				<Col xs={12} sm={12} md={12} lg={12} >
					{
						bannerList !== undefined ? (
							Object.keys(bannerList).length > 0 ? (
								Object.keys(bannerList).map((item, index) => (
									<Row className="py-2 bdrb2" key={`bann_${index}`} >
										<Col xs={12} sm={12} md={4} className="gal-img-item" >
											<img src={bannerList[item].url} />
										</Col>
										<Col xs={12} sm={12} md={8}>
											<Form.Group as={Row} className="mb-1">
												<Form.Label column sm={12} xs={12} md={4} lg={2}>Priority order : {bannerList[item].priority}</Form.Label>
												<Col sm={12} xs={12} md={8} lg={10}>
													<Form.Control onChange={(e) => {
														setBannerOrder(prev => ({
															...prev, [item.substring(1)]: parseInt(e.target.value)
														}));
													}} type="number" className="pr" autoComplete="off" onWheel={(e) => { e.target.blur() }} min="1" placeholder="Should be number" />
												</Col>
											</Form.Group>
											<Form.Group as={Row} className="mb-1">
												<Form.Label column sm={12} xs={12} md={4} lg={2}>Visibility</Form.Label>
												<Col sm={12} xs={12} md={8} lg={10} className="py-2" >
													{
														visId !== undefined && visId === item && visChangeLoad ? (
															<span className="please-wait-spinner p-2" ><Spinner animation="border" size="sm" /> Please wait...</span>
														) : (
															bannerList[item].status ? (
																<Button onClick={() => {
																	changeVisib(item, false);
																	setVisId(item);
																}} className="btn-disable" >Disable</Button>
															) : (
																<Button onClick={() => {
																	changeVisib(item, true);
																	setVisId(item);
																}} className="btn-enable" >Enable</Button>
															)
														)

													}
												</Col>
											</Form.Group>
											<Form.Group as={Row} className="mb-1">
												<Form.Label column sm={12} xs={12} md={4} lg={2}>Change image</Form.Label>
												<Col sm={12} xs={12} md={8} lg={10} className="py-2" >
													{
														changeImgId !== undefined && changeImgId === item && changeImgLoad ? (
															<span className="please-wait-spinner p-2" ><Spinner animation="border" size="sm" /> Please wait...</span>
														) : (
															<input onChange={(e) => {
																changeImg(item, e);
																setChangeImgId(item);
															}} type="file" id="change-img" accept=".png, .jpg, .jpeg" />
														)
													}
												</Col>
											</Form.Group>
											<Form.Group as={Row} className="mb-1">
												<Form.Label column sm={12} xs={12} md={4} lg={2}>Delete image</Form.Label>
												<Col sm={12} xs={12} md={8} lg={10} className="py-2" >
													{
														delId !== undefined && delId === item && delLoad ? (
															<Button className="btn-disable" ><span className="please-wait-spinner p-2" ><Spinner animation="border" size="sm" /> Please wait...</span></Button>
														) : (
															<Button onClick={() => {
																DeleteImg(item);
																setDelId(item);
															}} className="btn-disable" >Delete Image</Button>
														)
													}
												</Col>
											</Form.Group>
										</Col>
									</Row>
								))
							) : 'Nothing found!'
						) : 'Fetching data ...'
					}
					{
						bannerList !== undefined ? (
							Object.keys(bannerList).length > 0 ? (
								priorityChangeLoad ? (
									<Button className="btn-t1 align-end my-2" ><span className="please-wait-spinner p-2" ><Spinner animation="border" size="sm" /> Please wait...</span>
									</Button>
								) : (
									<Button onClick={() => { changePriority() }} className="btn-t1 my-2 align-end">Save Priority Order</Button>
								)
							) : ''
						) : ''
					}
				</Col>
			</Row>
		</Container>
	)
}